import type { Filter } from '../types/filter.type';

export const none: Filter = context => context;
